import { createSelector } from 'reselect';

export const fetchingClients = state => state.clients.get('isFetching');

export const allClients = state => state.clients.get('clients');
export const getAllClients = createSelector([allClients], clients => clients.toArray());
